<script>
  import { Spinner } from 'flowbite-svelte';
  import Layout from '../components/Layout.svelte';
  import { LoadingButton } from '@button/ui';
  import ProfileForm from '../components/forms/profile/ProfileForm.svelte';
  import { queryUserProfileQuery } from '../data/userData';
  import { _ } from 'svelte-i18n';

  export let open = false;

  let loading = false;
  let profileForm = null;

  const userProfile = queryUserProfileQuery();
</script>

<Layout>
  {#if $userProfile.isLoading}
    <div class="flex justify-center py-12">
      <Spinner />
    </div>
  {/if}
  {#if $userProfile.isSuccess}
    <form on:submit={profileForm.submitForm} class="w-full space-y-6">
      <ProfileForm
        bind:loading
        bind:this={profileForm}
        onSuccess={() => {
          open = false;
        }}
      />
      <div class="space-y-2">
        <LoadingButton class="w-full md:w-auto" type="submit" bind:loading
          >{$_('profileSettings.cta.update', {
            default: 'Update Profile',
          })}</LoadingButton
        >
      </div>
    </form>
  {/if}
</Layout>
